export default "__VITE_ASSET__B7DHc0vX__"